import { Address, Country } from 'src/service/backend/api'
import { COUNTRIES, CountryObject, getCountryObjectForCode } from 'src/service/view-model/base/country/Countries'

export interface ViewModelWithAddress {
  addressLine1: string
  addressLine2: string
  zipCode: string
  city: string
  latitude: string
  longitude: string
  countryCode?: CountryObject
}

export function mapAddress(viewModel: ViewModelWithAddress): Address {
  const countryCodeObj = viewModel.countryCode
  const countryCodeString = countryCodeObj ? (countryCodeObj.id as Country) : undefined

  const result: Address = {
    addressLine1: viewModel.addressLine1,
    addressLine2: viewModel.addressLine2,
    city: viewModel.city,
    zipCode: viewModel.zipCode,
    countryCode: countryCodeString ?? (COUNTRIES[0].id as Country),
    latitude: parseFloat(viewModel.latitude),
    longitude: parseFloat(viewModel.longitude),
  }

  return result
}

export function loadAddressViewModel(address: Address): ViewModelWithAddress {
  const result: ViewModelWithAddress = {
    addressLine1: address.addressLine1 || '',
    addressLine2: address.addressLine2 || '',
    zipCode: address.zipCode || '',
    city: address.city || '',
    latitude: address.latitude?.toString() || '',
    longitude: address.longitude?.toString() || '',
    countryCode: getCountryObjectForCode(address.countryCode) ?? {
      id: address.countryCode,
      name: address.countryCode,
      group: '',
    },
  }

  return result
}
